//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LazyHydrate from 'vue-lazy-hydration'
import VCarousel from '~/components/global/v/carousel'

export default {
  name: 'FullsizeGallery',
  components: {
    VCarousel,
    LazyHydrate
  },
  props: {
    currentIdx: {
      type: Number,
      default: 0
    },
    images: {
      type: Array,
      default: () => []
    },
    index: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      currentSlideIdx: 0
    }
  },
  computed: {
    getCount () {
      return this.images?.length
    }
  },
  mounted () {
    document.addEventListener('keydown', e => this.onKeyboard(e))
  },
  beforeDestroy () {
    document.removeEventListener('keydown', e => this.onKeyboard(e))
  },
  methods: {
    setSlideIdx (id) {
      this.currentSlideIdx = id
      this.$emit('changeSlide', id)
    },
    pinchZoom (i) {
      if (!this.$refs[`pinch-${i}`][0]) {
        return
      }
      try {
        this.$refs[`pinch-${i}`][0]?.toggleZoom()
      } catch (e) {
        console.log(e)
      }
    },
    nextSlide () {
      this.$emit('next')
      this.$refs.carousel.goToSlide('next')
    },
    prevSlide () {
      this.$emit('prev')
      this.$refs.carousel.goToSlide('prev')
    },
    onOpen () {
      this.$nextTick(() => {
        this.$refs.carousel.goToSlide(this.currentIdx)
      })
    },
    onKeyboard (event) {
      if (event.code === 'ArrowLeft') {
        this.prevSlide()
      }
      if (event.code === 'ArrowRight') {
        this.nextSlide()
      }
    }
  }
}
